

/**
 * @description
 * Controller for the profile screen
 * @param {object?} $scope Injects scope
 * @param {object?} $rootScope Injects $rootScope
 * @param {object} Collector Injects Collector services
 * @param {object} Auth Authentication service
 * @param {object} AlertMessages AlertMessages service
 * @param {object} Session The session service
 * @param {object} CheckUsername The check username service
 * @param {object} AUTH_EVENTS The AUTH_EVENTS constant
 * @param {object} NOTIFICATIONS The NOTIFICATIONS constant
 * @param {object} Notification The Notification service
 * @param {library} _ The Lodash library
 */
function CollectorController(
  $scope,
  $rootScope,
  Collector,
  Auth,
  AlertMessages,
  Session,
  CheckUsername,
  AUTH_EVENTS,
  NOTIFICATIONS,
  Notification,
  _
) {
  let vm = this;

  // Public methods
  vm.checkUsername = checkUsername;
  vm.verifyEmail = verifyEmail;

  // Defaults
  vm.updateProfile = updateProfile;

  // Define the profile object from the Collector
  vm.collector = _.cloneDeep(Session.collector);
  vm.collectorCompare = Session.collector;

  let deregister = $rootScope.$on(AUTH_EVENTS.collectorUpdated, function() {
    vm.collector = _.cloneDeep(Session.collector);
  });
  $scope.$on('$destroy', deregister);

 /**
  * @name updateProfile
  * @description Function to update the collector object
  * @param {number} imageId The ID of the profile photo
  */
  function updateProfile(imageId) {
    let _collector = vm.collector;
    if (!_.isUndefined(imageId)) {
      _collector.profile_photo = imageId;
    }

    // Check if the current email address has been changed. If so, set the
    // email_is_confirmed field to false
    if (vm.collector.email !== vm.collectorCompare.email) {
      _collector.email_is_confirmed = false;
      _collector.new_email = vm.collector.email;
      _collector.email = vm.collectorCompare.email;
    }
    Collector.updateProfile(_collector).then(function(updatedCollector) {
      if (updatedCollector) {
        vm.collector = _.cloneDeep(updatedCollector);
        vm.collectorCompare = _.cloneDeep(updatedCollector);
        Auth.updateSession();
        AlertMessages.add({
          msg: 'We saved your profile.',
          type: 'success'
        });

        // Send the confirm email notification, if needed
        if (updatedCollector.email_is_confirmed === false) {
          verifyEmail(updatedCollector);
        }
      }
    }, function(messages) {
      AlertMessages.add({msg:
      'We tried to update your profile, but something went wrong.',
      type: 'warning'});
    });
  }

  /**
   * @name verifyEmail
   * @description description
   * @param {type} collector The collector to verify email for
   */
  function verifyEmail(collector) {
    let confirmEmailNotification = {
      recipients: [collector.id],
      notificationId: NOTIFICATIONS.emailConfirmation,
      messageObjects: {
        collectorId: collector.id
      },
      messageVariables: {
        subject: 'Action required: please verify your email address'
      }
    };
    Notification.send(confirmEmailNotification);
  }

  /**
   * @name checkUsername
   * @description Function to check it a username exists when setting one
   * @param {string} username The username to check
   */
  function checkUsername(username) {
    CheckUsername.check(username, Session.collector.username)
    .then(function(results) {
      vm.usernameResults = results;
    });
  }
}

angular
  .module('inkfinder')
  .controller('CollectorController', CollectorController);



// WEBPACK FOOTER //
// ./components/collector/collector.controller.js